module.exports = __webpack_public_path__ + "static/media/valor3_2.ea4dcbf9.png";